import { Tenant } from "./tenant";

export class DeviceCategory {
  name: string;
  description: string;
  tenant: Tenant;
}
